import { Container, Dot } from './StepIndicator.styles';

export const StepIndicator = () => (
  <Container>
    <Dot />
  </Container>
);
